let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hGyPr")).then(() => parcelRequire('938pC'));